import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { useDashboardMetrics } from '@/hooks/queries/useDashboard';
import { ChartWidgetSkeleton, ChartWidgetError } from './WidgetSkeleton';

const COLORS: Record<string, string> = {
  NUEVO: '#3b82f6',
  EN_ANALISIS: '#8b5cf6',
  EN_DESARROLLO: '#6366f1',
  EN_PRUEBAS: '#06b6d4',
  RESUELTO: '#22c55e',
  CERRADO: '#6b7280',
  CANCELADO: '#ef4444',
};

const LABELS: Record<string, string> = {
  NUEVO: 'Nuevo',
  EN_ANALISIS: 'En Análisis',
  EN_DESARROLLO: 'En Desarrollo',
  EN_PRUEBAS: 'En Pruebas',
  RESUELTO: 'Resuelto',
  CERRADO: 'Cerrado',
  CANCELADO: 'Cancelado',
};

export function GraficoTicketsWidget() {
  const { data, isLoading, isError } = useDashboardMetrics();

  if (isLoading) return <ChartWidgetSkeleton />;
  if (isError || !data) return <ChartWidgetError message="Error al cargar gráfico de tickets" />;

  const chartData = Object.entries(data.tickets.por_estado)
    .filter(([_, value]) => value > 0)
    .map(([name, value]) => ({
      name: LABELS[name] || name.replace(/_/g, ' '),
      value,
      fill: COLORS[name] || '#6b7280',
    }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tickets por Estado</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              innerRadius={60}
              paddingAngle={2}
              label={({ percent }) =>
                percent && percent > 0.05 ? `${(percent * 100).toFixed(0)}%` : ''
              }
              labelLine={false}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [`${value} tickets`, '']}
            />
            <Legend
              verticalAlign="bottom"
              height={36}
              formatter={(value) => <span className="text-sm">{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
